export default "__VITE_ASSET__C9wfj7o1__"